import React, { useState } from 'react';
import { TabItem } from '../../commonComponents/TabItem';
import { ProPerks } from '../ProPerks/ProPerks';
import { PromotionsTab } from './PromotionsTab';
import { PromotionFormModal } from './PromotionFormModal';
import { DisablePromotionModal } from './DisablePromotionModal';
import { PayoutUploadModal } from './PayoutUploadModal';
import { useDownloadPayoutReport } from '../../../domain/Promotions';
import { showErrorMessage } from '../../../utils';
import { triggerBlobDownload } from './utils';
import { COLORS } from './constants';

const TABS = {
  PROMOTIONS: 'promotions',
  CHALLENGES: 'challenges',
};

const TAB_OPTIONS = [
  { value: TABS.PROMOTIONS, label: 'Promotions', default: true },
  { value: TABS.CHALLENGES, label: 'Challenges' },
];

export const ProPrograms = () => {
  const [activeTab, setActiveTab] = useState(TABS.PROMOTIONS);
  // modal = { type: 'create' | 'edit' | 'disable' | 'reactivate' | 'payout', promotion } | null
  const [modal, setModal] = useState(null);

  const closeModal = () => setModal(null);
  const openCreate = () => setModal({ type: 'create', promotion: null });
  const openEdit = (promotion) => setModal({ type: 'edit', promotion });
  const openDisable = (promotion) => setModal({ type: 'disable', promotion });
  const openReactivate = (promotion) => setModal({ type: 'reactivate', promotion });
  const openPayout = (promotion) => setModal({ type: 'payout', promotion });

  const isPromotions = activeTab === TABS.PROMOTIONS;

  const downloadReport = useDownloadPayoutReport({
    onSuccess: ({ blob, filename }) => triggerBlobDownload(blob, filename),
    onError: () =>
      showErrorMessage({ message: 'Could not download the payout report.' }),
  });

  const handleViewReport = (promotion, batch, outcome) =>
    downloadReport.mutate({
      promotionId: promotion.id,
      batchId: batch.batchId,
      outcome,
    });

  return (
    <div
      style={{
        // Promotions is a compact list; ProPerks (Challenges) is a full-width
        // page and must not be squeezed into the narrow column.
        maxWidth: isPromotions ? 1100 : 'none',
        margin: '0 auto',
        padding: '24px 16px',
      }}
    >
      <h1 style={{ textAlign: 'center', fontSize: 24, color: COLORS.text }}>
        ProPrograms
      </h1>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 12,
          margin: '16px 0 24px',
        }}
      >
        {TAB_OPTIONS.map((tab) => (
          <TabItem
            key={tab.value}
            tab={tab}
            value={activeTab}
            onValueChanged={setActiveTab}
          />
        ))}
      </div>

      {isPromotions ? (
        <PromotionsTab
          onAddPromotion={openCreate}
          onEditPromotion={openEdit}
          onAddPayout={openPayout}
          onReactivate={openReactivate}
          onViewReport={handleViewReport}
        />
      ) : (
        <ProPerks />
      )}

      {(modal?.type === 'create' || modal?.type === 'edit') && (
        <PromotionFormModal
          mode={modal.type}
          promotion={modal.promotion}
          onClose={closeModal}
          onRequestDisable={openDisable}
        />
      )}

      {modal?.type === 'disable' && (
        <DisablePromotionModal promotion={modal.promotion} onClose={closeModal} />
      )}

      {modal?.type === 'reactivate' && (
        <DisablePromotionModal
          promotion={modal.promotion}
          mode="reactivate"
          onClose={closeModal}
        />
      )}

      {modal?.type === 'payout' && (
        <PayoutUploadModal promotion={modal.promotion} onClose={closeModal} />
      )}
    </div>
  );
};

export default ProPrograms;
